const env = {
  dev: {
    publicUrl: "http://localhost:3000"
  },
  prod: {
    publicUrl: "http://strata-staging.strata.com.s3-website-us-west-2.amazonaws.com"
  }
};

const stage =
  process.env.REACT_APP_STAGE === undefined
    ? "dev"
    : process.env.REACT_APP_STAGE;

console.log(process);
export const config = {
  ...env[stage]
};
